// extracted by mini-css-extract-plugin
var _1 = "disabled--S4pvg";
var _2 = "labelText--C3HPK";
var _3 = "toggleContainer--vJ3Fi";
var _4 = "toggleInput--izLZm";
var _5 = "toggleLabel--izqEe";
var _6 = "toggleSlider--Kal5e";
var _7 = "toggleSwitch--ldVss";
export { _1 as "disabled", _2 as "labelText", _3 as "toggleContainer", _4 as "toggleInput", _5 as "toggleLabel", _6 as "toggleSlider", _7 as "toggleSwitch" }
